import { render, staticRenderFns } from "./required-training.vue?vue&type=template&id=72c7f972&"
import script from "./required-training.vue?vue&type=script&lang=js&"
export * from "./required-training.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports